import { throttleComplete } from '@utils/throttle';
const header = document.querySelector('.header');
let previousScrollTop = 0;
const getScrollTop = () => (document.body.scrollTop || document.documentElement.scrollTop);
const handleScroll = () => {
    if (header) {
        const currentScrollTop = getScrollTop();
        const isScrollingUp = currentScrollTop < previousScrollTop;
        const isHeaderVisible = currentScrollTop < header.offsetHeight;
        header.classList.toggle('header--hidden', !isScrollingUp && !isHeaderVisible);
        header.classList.toggle('header--scrolled', currentScrollTop > 110);
        previousScrollTop = currentScrollTop;
    }
};
window.addEventListener('scroll', throttleComplete(handleScroll, 100));
